import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useFetchEvaluacion = (id, evaluadorDni) => {
  const [response, setResponse] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url = `desempeno_detalle_list/${id}`
        if (evaluadorDni) {
          url += `?evaluador_dni=${evaluadorDni}`
        }
        const result = await axios.get(url)
        setResponse(result.data)
      } catch (error) {
        setError(error.response?.data || error.message || 'Error al cargar los datos')
      } finally {
        setLoading(false)
      }
    }
    if (id) {
      fetchData()
    }
  }, [id, evaluadorDni])

  return { response, loading, error }
}

export default useFetchEvaluacion
